export class RetailerXLSXData {
  EAN: string;
  price: number;
  internalCode: string;
  purchasePrice: number;
  discountPrice: number;

  constructor(EAN: string, price: number, internalCode: string, purchasePrice: number, discountPrice: number) {
    this.EAN = EAN;
    this.price = price ?? 0;
    this.internalCode = internalCode ?? '';
    this.purchasePrice = purchasePrice ?? 0;
    this.discountPrice = discountPrice ?? null;
  }
}
